import React, { useState } from 'react';
import { getTheme, setTheme } from './index';
import { tr } from '../i18n';
import './ThemeSwitcher.css';

// Footer button: a sun in dark mode (click for light), a moon in light mode.
export default function ThemeSwitcher() {
  const [theme, setThemeState] = useState(getTheme());
  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      className={`theme-switch fas ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`}
      title={next === 'light' ? tr('Switch to light mode') : tr('Switch to dark mode')}
      aria-label={next === 'light' ? tr('Switch to light mode') : tr('Switch to dark mode')}
      onClick={() => {
        setTheme(next);
        setThemeState(next);
      }}
    />
  );
}
